import { NgTemplateOutlet, NgClass } from '@angular/common'
import { Component, inject, Input, OnDestroy, OnInit, output, Renderer2, TemplateRef } from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { HtmlAttributesDirective } from 'src/app/shared/directives/html-attributes.directive'
import { SidebarNavBadgePipe } from '../sidebar-nav-badge.pipe'
import { SidebarNavIconPipe } from '../sidebar-nav-icon.pipe'
import { NavItem } from '../nav-item.interface'
import { SidebarNavHelper } from '../sidebar-nav.service'
import { SidebarNavLinkPipe } from '../sidebar-nav-link.pipe'
import { filter, Observable, Subscription } from 'rxjs'
import { NgxPermissionsModule } from 'ngx-permissions'

@Component({
    selector: 'sq-sidebar-nav-link-content',
    template: `
        @if (true) {
            <ng-container>{{ item?.name ?? '' }}</ng-container>
        }
    `,
    providers: [SidebarNavHelper],
})
export class SidebarNavLinkContentComponent {
    readonly helper = inject(SidebarNavHelper)

    @Input() item?: NavItem
}

@Component({
    selector: 'sf-sidebar-nav-link',
    imports: [
        FontAwesomeModule,
        RouterModule,
        SidebarNavLinkContentComponent,
        HtmlAttributesDirective,
        SidebarNavLinkPipe,
        SidebarNavIconPipe,
        SidebarNavBadgePipe,
        NgTemplateOutlet,
        NgClass,
    ],
    templateUrl: './sidebar-nav-link.component.html',
    styleUrl: './sidebar-nav-link.component.scss',
})
export class SidebarNavLinkComponent implements OnInit, OnDestroy {
    readonly router = inject(Router)
    readonly renderer2 = inject(Renderer2)

    protected _item: NavItem = {}

    @Input()
    set item(item: NavItem) {
        this._item = JSON.parse(JSON.stringify(item))
    }

    get item(): NavItem {
        return this._item
    }

    readonly linkClick = output()

    public linkType!: string
    public href!: string
    public linkActive!: boolean
    private url!: string

    private navigationEndObservable: Observable<NavigationEnd>
    private navSubscription!: Subscription

    constructor() {
        const router = this.router

        this.navigationEndObservable = router.events.pipe(
            filter((event) => {
                return event instanceof NavigationEnd
            })
        ) as Observable<NavigationEnd>
    }

    ngOnInit(): void {
        this.url =
            typeof this.item.url === 'string'
                ? this.item.url
                : this.router.serializeUrl(this.router.createUrlTree((this.item.url as any[]) ?? ['']))
        this.linkType = this.getLinkType()
        this.href = this.isDisabled() ? '' : this.item.href || this.url
        this.linkActive = this.router.url.split(/[?#(;]/)[0] === this.href.split(/[?#(;]/)[0]
        this.navSubscription = this.navigationEndObservable.subscribe((event) => {
            const itemUrlArray = this.href.split(/[?#(;]/)[0].split('/')
            const urlArray = event.urlAfterRedirects.split(/[?#(;]/)[0].split('/')
            this.linkActive = itemUrlArray.every((value, index) => value === urlArray[index])
        })
    }

    ngOnDestroy(): void {
        this.navSubscription?.unsubscribe()
    }

    public getLinkType(): string {
        return this.isDisabled() ? 'disabled' : this.isExternalLink() ? 'external' : 'link'
    }

    public isDisabled(): boolean {
        return this.item?.attributes?.['disabled']
    }

    public isExternalLink(): boolean {
        const linkPath = Array.isArray(this.item.url) ? this.item.url[0] : this.item.url
        return !!this.item.href || linkPath?.substring(0, 4) === 'http'
    }

    linkClicked(): void {
        this.linkClick.emit()
    }
}
